import React from "react"
import {
  useEnterpriseGetOne,
  useMainEnterpriseId,
} from "../../../../../../../hooks/enterprise"
import LayoutMain from "../../../../../../../components/Layouts/LayoutMain"
import { useShopGetOne, useShopId } from "../../../../../../../hooks/shop"
import LayoutLoadingAuthRequired from "../../../../../../../components/Layouts/LayoutLoadingAuthRequired"
import OrderHeadLine from "../../../../../../../components/Order/OrderHeadLine"
import OrderList from "../../../../../../../components/Order/OrderList"
import HeaderSelectTop from "../../../../../../../components/Headers/HeaderSelectTop"
import Link from "next/link"
import { ArrowLeft } from "lucide-react"
import { useShopSalePointId } from "../../../../../../../hooks/shopSalePoint"

const Title = "Выберите действие"

function OrdersPage() {
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()
  const shopSalePointId = useShopSalePointId()

  const { isLoading: isLoadingEnterprise, isError: isErrorEnterprise } =
    useEnterpriseGetOne(enterpriseId)
  const { isLoading: isLoadingShop, isError: isErrorShop } = useShopGetOne(
    enterpriseId,
    shopId
  )

  if (
    isLoadingEnterprise ||
    isLoadingShop ||
    isErrorEnterprise ||
    isErrorShop
  ) {
    return (
      <React.Fragment>
        <LayoutLoadingAuthRequired
          isLoading={isLoadingEnterprise || isLoadingShop}
          isError={isErrorEnterprise || isErrorShop}
        />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <LayoutMain title={Title}>
        <HeaderSelectTop>
          <Link
            href={`/e/${enterpriseId}/s/${shopId}/${shopSalePointId}`}
            className="inline-flex items-center rounded-md border border-border bg-card px-4 py-2 text-sm font-medium text-foreground shadow-xs transition-colors hover:bg-muted focus:ring-2 focus:ring-ring focus:outline-none"
          >
            <ArrowLeft
              className="mr-2 size-4 text-muted-foreground"
              aria-hidden="true"
            />
            <span>Назад</span>
          </Link>
        </HeaderSelectTop>

        <div className="mx-auto flex max-w-7xl flex-1 flex-col justify-center px-8 py-8">
          <OrderHeadLine />

          <OrderList />
        </div>
      </LayoutMain>
    </React.Fragment>
  )
}

export default OrdersPage
